"use strict";

// "use strict";

jQuery(document).ready(function ($) {
  // console.log('ready');
});